export default {
	methods: {
		confirmClickToExternal(link){
			this.$store.dispatch('vorbasse/showPrompt',{
				title: 'Er du sikker?',
				prompt: 'Dette link fører væk fra Vorbasse Hjemmemarked og åbner et nyt vindue. Er du sikker på at du vil gå til den nye side?',
				confirmText: 'Ja, fortsæt'
			})
			.then(result => {
				window.open(link, '_blank')
			})
		},
	}
}
